const ROUTE_PATHS = {
  HOME: "/",
  SIGNUP_SUCCESS: "/message",
  TYPEFORM: "/typeform/:id",
  TYPEFORM_REVIEW_REPORT: "/review-report/:id",
  SCHEDULE: "/schedule",
  MY_PROFILE: "/my-profile",
  SETTINGS: "/settings",
  RECORDING_VIEWER: "/meeting-recording/:token",
  AUTH: {
    REDIRECT_URL: "/auth",
    LOGIN: "/login",
    SIGNUP: "/signup",
    SIGNUP_AMBASSADOR: "/ambasador-signup",
    SIGNUP_VENDOR: "/vendor-signup",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    SET_PASSWORD: "/set-password",
    SIGNUP_MORE_ABOUT_AMBASSADOR_COMPANY: "/more-about-ambassador-company",
    SIGNUP_MORE_ABOUT_VENDOR_COMPANY: "/more-about-vendor-company",
  },
  PROJECT: {
    LIST: "/project",
    NEW_INVITATION_REVIEW: "/project/new-project/invitation-review",
    PROJECT_DETAILS_INVITATION_ID: "/project/invitation/:id",
    PROJECT_DETAILS_INVITATION_ID_NO_AUTH: "/project/invitation/preview/:id",
    NEW_PROJECT: "/project/new-project",
    INVITATION_DECLINE: "/project/invitation-decline",
    INVITATION_REMINDER: "/project/invitation-reminder/:id",
  },
  OPPORTUNITY: "/vendor-opportunity",
  OPPORTUNITY_FORM: "/opportunity-request/:id",
  MARKETPLACE_FORM: "/marketplace-request/:id",
  MARKETPLACE_PROFILE: "/marketplace/profile/:id",
  MARKETPLACE: "/marketplace",
  MEETING_SUMMARY: "/meeting-summary/:token",
  MEETING_RECORDINGS: {
    LIST: "/meeting-recordings",
  },
  INITIATIVES: {
    LIST: "/initiatives",
  },
};

export { ROUTE_PATHS };
